<template lang="pug">
  .component-driver-reservation-request(v-if="item")
    .card
      .inner-content(v-if="$is('listing')" )
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              ChargingSessionButtons(:item="item")
          .column.shrink
            .label CS{{item.id}}
            .value Port {{item.port}}
          .column
            .label UUID
            .value {{item.uuid}}
          .column
            .label Start
            .value {{item.start}}
          .column
            .label End
            .value {{item.end}}
          .column
            .label Status
            .value {{item.status}}
          .column
            .label Reservation
            div
              router-link(:to="{name:'reservation', params:{id:item.reservation_id}}")
                span R{{item.reservation_id}}
      .inner-content(v-if="$is('reservation')" )
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              ChargingSessionButtons(:item="item")
          .row
            .column.shrink
              .label CS{{item.id}}
              .value Port {{item.port}}
            .column
              .label UUID
              .value {{item.uuid}}
        .row
          .column
            .label Start
            .value {{item.start}}
          .column
            .label End
            .value {{item.end}}
          .column
            .label Status
            .value {{item.status}}

</template>

<script>
import Dropdown from '../structure/foundation/Dropdown'
import ChargingSessionButtons from "../structure/ui/actions/ChargingSessionButtons.vue";

export default {
  name: 'ChargingSession',
  components: {ChargingSessionButtons, Dropdown},
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>

<style lang="sass">
.component-driver-reservation-request
  .fa-check
    color: green

  .fa-times
    color: red
</style>



// WEBPACK FOOTER //
// ChargingSession.vue?539f0201